import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {updateLastAutoRecommendationAction} from '../../../store/data/preferences/preferencesActions';
import {getLastAutoRecommendation} from '../../../store/data/preferences/preferencesSelectors';
import {visualWorkspaceHasUndefinedIsRecentlyViewed} from '../../../store/data/workspace/visualWorkspace/visualWorkspaceHelpers';
import {
  getShouldShowP1AutoRecBanner,
  getUserVisualWorkspace,
} from '../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {updateWorkspaceAsyncAction} from '../../../store/data/workspace/workspaceActions';
import {
  getHasP1AutoRec,
  getShouldHideAssignedConversations,
} from '../../../store/featureFlags/featureFlagsSelectors';
import {Workspaces} from './workspaces';

/*
 * Constants.
 */

const dayInMilliseconds = 86400000;

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  visualWorkspace: getUserVisualWorkspace,
  hasP1AutoRec: getHasP1AutoRec,
  lastAutoRecommendation: getLastAutoRecommendation,
  shouldShowP1AutoRecBanner: getShouldShowP1AutoRecBanner,
  shouldHideAssignedConversations: getShouldHideAssignedConversations,
}));

export const WorkspacesContainer = connect(
  mapStateToProps,
  {
    updateLastAutoRecommendation: updateLastAutoRecommendationAction,
    updateWorkspace: updateWorkspaceAsyncAction,
  },
  (stateProps, dispatchProps, ownProps) => {
    const {visualWorkspace, lastAutoRecommendation} = stateProps;
    const {updateLastAutoRecommendation, updateWorkspace} = dispatchProps;

    /*
     * Potentially
     * 1) initialize lastAutoRecommendation timestamp if it has never been set before and
     * 2) push the current visual workspace if any item in visual workspace has an undefined isRecentlyViewed property.
     * */
    const maybeUpdatePreferencesAndWorkspace = () => {
      if (lastAutoRecommendation === undefined) {
        // Adding an extra day to the current time so there is a sufficient gap
        // between setting lastAutoRecommendation and setting timestamps for workspace items.
        updateLastAutoRecommendation(Date.now() + dayInMilliseconds);
      }

      if (visualWorkspaceHasUndefinedIsRecentlyViewed(visualWorkspace)) {
        updateWorkspace(visualWorkspace);
      }
    };

    return {
      ...stateProps,
      ...ownProps,
      maybeUpdatePreferencesAndWorkspace,
    };
  },
)(Workspaces);
